export const agentPipelineChartOptions = {
    chart: {
        type: 'column',
        width: 900,
        height: 600,
        backgroundColor: 'transparent',
        options3d: {
            enabled: true,
            alpha: 10,
            beta: 0,
            depth: 50,
        },
    },
    title: {
        text: 'Agent Pipeline',
        margin: 30,
        style: {
            fontWeight: 'bold',
        }
    },
    tooltip: {
        headerFormat: '<b>{point.key}</b><br>',
        pointFormat: '{series.name}: <b>{point.y:,.2f}</b>',
    },
    credits: {
        enabled: false,
    },
    legend: {
        itemStyle: {
            fontSize: '13px',
            fontWeight: 'normal',
        },
    },
    plotOptions: {
        column: {
            depth: 25,
            cursor: 'pointer',
        },
        series: {
            groupPadding: 0.1
        }
    },
    xAxis: {
        categories: [],
        labels: {
            skew3d: true,
            style: {
                fontSize: '13px'
            }
        }
    },
    yAxis: {
        title: {
            text: null,
        },
        labels: {
            format: '${value:,.2f}'
        },
        tickInterval: 250000,
    },
    series: [],
};